import { render, staticRenderFns } from "./PurchaseDeliveryAdd.vue?vue&type=template&id=855b1d54&scoped=true"
import script from "./PurchaseDeliveryAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseDeliveryAdd.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDeliveryAdd.vue?vue&type=style&index=0&id=855b1d54&prod&lang=scss"
import style1 from "./PurchaseDeliveryAdd.vue?vue&type=style&index=1&id=855b1d54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855b1d54",
  null
  
)

export default component.exports